import { IQueryConditionHandler } from "./iquerycondition.handler";

import { CompareType } from '../enum/compare-type.enum';
import { ValueType } from '../enum/value-type.enum';
import { RelationType } from '../enum/relation-type.enum';
import { NumberRangeValue } from '../../entity/conditionvalue/numberrangevaue';
import { QueryCondition } from '../../entity/querycondition';

export class NumberRangeHandler implements IQueryConditionHandler{
    convert(qc: QueryCondition) {
        const arr = [];
        const nrv = (qc.value as NumberRangeValue);
        if(Object.keys(nrv).length === 0)
            return arr;
        (nrv.startValue != null) && arr.push({
            'FilterField' : qc.fieldCode,
            'Compare' : CompareType.GreaterThanOrEqual, //GreaterOrEqual
            'Value' : nrv.startValue,
            'Relation' : RelationType.And, //and
            'Expresstype': ValueType.Value
        });
        (nrv.endValue != null) && arr.push({
            'FilterField' : qc.fieldCode,
            'Compare' : CompareType.LessThanOrEqual, //LessOrEqual
            'Value' : nrv.endValue,
            'Relation' : RelationType.And,//and
            'Expresstype': ValueType.Value
        });

        return arr;
    }
}